module.exports = __webpack_public_path__ + "img/3.903cb320.webp";